module.exports = __webpack_public_path__ + "static/img/vssszovits.008b8de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/vssszovits.png
// module id = +Sw7
// module chunks = 0